export default () => {
  const headers = document.querySelectorAll('.js-sticky-header')
  let scrollPos = 0
  let scrolledUp = false

  if (headers.length < 1) return

  window.addEventListener('scroll', handleScroll)

  function handleScroll() {
    scrolledUp = document.body.getBoundingClientRect().top > scrollPos

    // loop through all headers
    ;[...headers].forEach(header => {
      // we're NOT at the top of the page
      if (window.pageYOffset > 300) {
        // we're scrolling up
        if (scrolledUp) {
          if (!header.classList.contains('active')) {
            header.classList.add('active')
          }
          // we're scrolling down
        } else {
          if (header.classList.contains('active')) {
            header.classList.remove('active')
          }
        }

        // we're at the top of the page
      } else {
        if (header.classList.contains('active')) {
          header.classList.remove('active')
        }
      }
    })

    // saves the new position for iteration.
    scrollPos = document.body.getBoundingClientRect().top
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/StickyHeader.js